import types from "../types/types";

const documentations = (documentations) => (dispatch) => {
  dispatch({
    type: types.SET_DOCUMENTATIONS,
    payload: documentations,
  });
};
export default documentations;
